<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
  watch: {},
  computed: {}, 
  mounted() {}
};
</script>

<style lang="less" rel="stylesheet/less">
</style>


// WEBPACK FOOTER //
// src/components/chapter/testQuestions.vue